//AUTH
export const loginApi = "/auth/login"
export const registerStudentApi = "/auth/register"

//ABOUTME
export const aboutmeApi = "/aboutme"

//METRICS
export const socialsApi = "/socials"
export const genderApi = "/gender"
export const ageApi = "/age"
export const locationApi = "/location"

//CONTENT (REDES SOCIALES)
export const contentApi = "/content"

//GALLERY (ENTREVISTAS)
export const galleryApi = "/gallery"

//INFLUENCERS (PROYECTOS)
export const influencersApi = "/influencers"
export const socialLinksApi = "/social"
export const videosApi = "/videos"

//TEXT
export const textApi = "/text"

//UPLOADS
export const uploadImageApi = "/upload/image"
export const uploadImageInfluencerApi = "/upload/image-influencer"
export const uploadImageVideoApi = "/upload/image-video"
export const deleteImageApi = "/upload/image"